<p *ngIf="selectedCondition.showFieldDeletedWarning" class="error-message">
  This field no longer exists. Remove it then click Save.
</p>
<div class="filter-item" [class.sub-condition]="isSubCondition">
  <p class="condition-prfx" *ngIf="!hideAddRemove">
    <b>{{ index == 0 ? (isSubCondition ? 'With' : 'Where') : 'And' }}</b>
  </p>
  <div class="filter-query">
    <mat-form-field
      class="condition-field"
      appearance="outline"
      floatLabel="always"
      [class.mat-form-field-invalid]="selectedCondition.isFilterApplied && !selectedCondition.filter"
    >
      <input
        type="text"
        placeholder="Search conditions..."
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto"
        aria-label="Search for a condition"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="autocompleteSelectedChanged($event.option.value)"
      >
        <mat-option *ngFor="let condition of availableConditions" [value]="condition">{{
          condition.displayName
        }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div *ngIf="selectedCondition.filter">
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        class="dropdown-field"
        [class.mat-form-field-invalid]="selectedCondition.isFilterApplied && !selectedCondition.filterOperator"
      >
        <mat-select
          [(ngModel)]="selectedCondition.filterOperator"
          (selectionChange)="onOperatorsSelectionChange()"
          aria-label="Select an operator"
        >
          <mat-option *ngFor="let op of operators" [value]="op">{{ op.displayName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      *ngIf="
        selectedCondition.filter &&
        selectedCondition.filterOperator &&
        selectedCondition.filterOperator.isSearchValueNeeded
      "
    >
      <multiselect
        *ngIf="selectedCondition.uiType == uiType.Multiselect"
        [items]="multiselectItems"
        [selectedItems]="selectedMultiselectItems"
        (selectionChanged)="multiselectSelectionChanged($event)"
        [placeholder]="'Select items...'"
        [required]="selectedCondition.isFilterApplied"
        [isTouched]="selectedCondition.isFilterApplied"
        aria-label="Select a value or values"
      ></multiselect>
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        fxFlex
        class="dropdown-field"
        *ngIf="selectedCondition.uiType == uiType.DropDown"
        [class.mat-form-field-invalid]="
          (selectedCondition.isFilterApplied || selectedCondition.isSubFilterAdded) &&
          (selectedCondition.searchValue == null || selectedCondition.searchValue.toString() == '')
        "
      >
        <mat-select
          [(ngModel)]="selectedCondition.searchValue"
          (selectionChange)="selectedCondition.isFilterApplied = false"
          aria-label="Select a value"
        >
          <ng-container *ngIf="selectedCondition.filter.valueType == 'List'">
            <mat-option *ngFor="let value of selectedCondition.filter.values" [value]="value">{{ value }}</mat-option>
          </ng-container>
          <ng-container *ngIf="selectedCondition.filter.valueType == 'Boolean'">
            <mat-option *ngFor="let value of selectedCondition.filter.values" [value]="value.searchValue">{{
              value.name
            }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <div
        class="inputs"
        *ngIf="selectedCondition.uiType == uiType.Textbox || selectedCondition.uiType == uiType.DatePicker"
      >
        <mat-form-field
          *ngIf="selectedCondition.uiType == uiType.Textbox"
          appearance="outline"
          fxFlex
          [class.mat-form-field-invalid]="
            (selectedCondition.isFilterApplied || selectedCondition.isSubFilterAdded) && !selectedCondition.searchValue
          "
        >
          <input
            matInput
            [type]="inputType"
            [(ngModel)]="selectedCondition.searchValue"
            (change)="selectedCondition.searchValue = selectedCondition.searchValue.trim()"
            (ngModelChange)="selectedCondition.isFilterApplied = false"
            [placeholder]="textBoxPlaceholder"
            aria-label="Type a value"
          />
        </mat-form-field>
        <mat-form-field
          *ngIf="selectedCondition.uiType == uiType.DatePicker"
          appearance="outline"
          fxFlex
          [class.mat-form-field-invalid]="
            (selectedCondition.isFilterApplied || selectedCondition.isSubFilterAdded) && !selectedCondition.searchValue
          "
        >
          <input
            matInput
            [matDatepicker]="datePicker"
            [(ngModel)]="selectedCondition.searchValue"
            (ngModelChange)="selectedCondition.isFilterApplied = false"
            aria-label="Select or type a date value"
          />
          <mat-datepicker-toggle matSuffix [for]="datePicker"> </mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <button
    mat-icon-button
    color="primary"
    (click)="addSubCondition.emit()"
    aria-label="Add Sub-Condition"
    *ngIf="showAddSubConditionButton"
  >
    <mat-icon>add_circle</mat-icon>
  </button>
  <button mat-icon-button color="primary" (click)="onDelete()" aria-label="Delete condition" *ngIf="!hideAddRemove">
    <mat-icon>delete</mat-icon>
  </button>
</div>
